import useRecommendedRoutes from './useRecommendedRoutes';

export default useRecommendedRoutes;